import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { Button, Form, Input, Modal, Spin, Tag } from "antd";
import InfiniteScroll from 'react-infinite-scroller';
import { axiosErrorHandler } from "../../../swzutils";
import './DriverChatModal.css';
import CommunicationType from "../enums/CommunicationType";
import { formatDateTime } from "../../../util/FormatUtil";
const PAGE_SIZE = 20;
const DriverChatModal = ({ open, onClose, driver }) => {
    const [stateLoadingChat, setStateLoadingChat] = useState(false);
    const [stateSendingMessage, setStateSendingMessage] = useState(false);
    const [stateHasMore, setStateHasMore] = useState(false);
    const [stateChatHistory, setStateChatHistory] = useState([]);
    const [stateLimit, setStateLimit] = useState(0);
    const formRef = useRef(null);
    const bottomOfChat = useRef(null);
    useEffect(() => {
        // Clear on close
        if (!open) {
            setStateChatHistory([]);
            setStateHasMore(false);
            setStateLimit(0);
        }
        if (open && driver) {
            loadCommunicationHistory();
        }
    }, [open, driver]);
    /**
     * Hacks,
     * We want to scroll to the bottom of the chat window, but we can only scroll AFTER the list elements have been
     * rendered to the Browser DOM by React, this takes a setTimeout hammer and a requestAnimationFrame mallet to the
     * problem
     */
    const onNextFrame = (callback) => {
        setTimeout(function () {
            requestAnimationFrame(callback);
        });
    };
    const scrollToBottomOfChat = () => {
        bottomOfChat.current?.scrollIntoView({ block: "end", inline: "nearest" });
    };
    const loadCommunicationHistory = (limit = PAGE_SIZE) => {
        setStateLoadingChat(true);
        if (!driver) {
            return;
        }
        axios.get(`/admin/v1/drivers/${driver.id}/communications?limit=${limit}`)
            .then(response => {
            setStateChatHistory(response.data.results.reverse());
            setStateHasMore(response.data.maxResults > limit);
            setStateLimit(limit);
        })
            .catch(axiosErrorHandler)
            .finally(() => {
            setStateLoadingChat(false);
        });
    };
    const onSubmit = () => {
        formRef.current.validateFields().then(formValues => {
            sendMessage(formValues.title, formValues.message);
        }).catch(errorInfo => console.error(errorInfo)); // This has to be present otherwise antd crashes :(
    };
    const handleInfiniteOnLoad = () => {
        loadCommunicationHistory(stateLimit + PAGE_SIZE);
    };
    const sendMessage = (title, message) => {
        setStateSendingMessage(true);
        const request = {
            title: title,
            message: message
        };
        axios.post(`/admin/v1/drivers/${driver.id}/communications`, request)
            .then(( /*response*/) => {
            formRef.current.resetFields();
            loadCommunicationHistory();
            onNextFrame(scrollToBottomOfChat);
        })
            .catch(axiosErrorHandler)
            .finally(() => {
            setStateSendingMessage(false);
        });
    };
    const renderTypeTag = (chat) => {
        const chatType = CommunicationType.valueOf(chat.type);
        if (!chatType) {
            console.error("Unknown chat type " + chat.type);
        }
        return _jsx(Tag, { color: "default", children: chatType?.shortDescription });
    };
    return (_jsxs(Modal, { open: open, onCancel: onClose, title: `Driver Chat - ${driver?.firstName} ${driver?.lastName}`, centered: true, width: 800, footer: [
            _jsx(Button, { onClick: onClose, children: "Close" }, "back"),
            _jsx(Button, { type: "primary", loading: stateSendingMessage, onClick: onSubmit, children: "Send Message" }, "submit"),
        ], children: [_jsx("div", { className: "driver-chat-modal-chat-history-container", children: _jsx(InfiniteScroll, { threshold: 5, isReverse: true, initialLoad: false, pageStart: 0, loadMore: handleInfiniteOnLoad, hasMore: !stateLoadingChat && stateHasMore, useWindow: false, children: _jsxs(Spin, { spinning: stateLoadingChat, children: [stateChatHistory.map(chat => {
                                return (_jsxs("div", { children: [_jsxs("p", { children: [chat.sentByUser &&
                                                    _jsxs("b", { children: [chat.sentByUser.firstName, " ", chat.sentByUser.lastName] }), _jsxs("span", { className: "pull-right", children: [renderTypeTag(chat), " ", formatDateTime(chat.sentAt)] })] }), _jsx("p", { children: "message" in chat ? chat.message : null }), _jsx("hr", {})] }));
                            }), _jsx("div", { ref: bottomOfChat })] }) }) }), _jsx("hr", {}), _jsx(Form, { layout: "vertical", ref: formRef, children: _jsx(Form.Item, { label: "Message", name: "message", rules: [{ required: true, message: 'Please enter a message' }], children: _jsx(Input.TextArea, { disabled: stateSendingMessage, autoSize: {
                            minRows: 4
                        } }) }) })] }));
};
export default DriverChatModal;
